import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { AuthService } from '../core/services/auth.service';
import { first } from 'rxjs';
import { LanguageService } from '../core/interceptor/language.service';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { InputComponent } from '../shared/components/input/input.component';
import { ButtonComponent } from '../shared/components/button/button.component';

@Component({
  selector: 'app-forgottenpassword',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    TranslatePipe,
    InputComponent,
    ButtonComponent
  ],
  templateUrl: './forgottenpassword.component.html',
  styleUrl: './forgottenpassword.component.scss'
})
export class ForgottenpasswordComponent implements OnInit {
  forgotPasswordForm!: FormGroup;
  successMessage: string | null = null;
  error: string | null = null;
  showButtonConfirme: boolean = true;
  loading: boolean = false;
  currentYear: number = new Date().getFullYear();

  constructor(
    private fb: FormBuilder,
    private userService: AuthService,
    private router: Router,
    private translate: TranslateService,
    private languageService: LanguageService
  ) {}

  ngOnInit(): void {
    this.languageService.initializeTranslation();
    this.forgotPasswordForm = this.fb.group({
      username: [
        '',
        [
          Validators.required,
          Validators.email,
          Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)
        ]
      ],
    });
  }

  get emailError(): string | null {
    const control = this.forgotPasswordForm?.get('username');
    if (!control || !control.touched || !control.invalid) {
      return null;
    }
    if (control.hasError('required')) {
      return this.translate.instant('FORGOT_PASSWORD.EMAIL_REQUIRED');
    }
    if (control.hasError('email') || control.hasError('pattern')) {
      return this.translate.instant('FORGOT_PASSWORD.EMAIL_INVALID');
    }
    return null;
  }

  onSubmit(event?: Event): void {
    if (event) {
      event.preventDefault();
    }
    if (!this.forgotPasswordForm.valid) {
      this.forgotPasswordForm.markAllAsTouched();
      return;
    }

    const username = (this.forgotPasswordForm.value.username || '').trim();
    this.successMessage = null;
    this.error = null;
    this.loading = true;

    this.userService.forgottentPassword(username)
      .pipe(first())
      .subscribe({
        next: () => {
          this.loading = false;
          this.successMessage = this.translate.instant('FORGOT_PASSWORD.SUCCESS.EMAIL_SENT', { email: username });
          this.showButtonConfirme = false;
          setTimeout(() => {
            this.router.navigate(['/login']);
          }, 6000);
        },
        error: (err: any) => {
          this.loading = false;
          switch (err.status) {
            case 0:
              this.error = this.translate.instant('FORGOT_PASSWORD.ERRORS.CONNECTION');
              break;
            case 408:
              this.error = this.translate.instant('FORGOT_PASSWORD.ERRORS.TIMEOUT');
              break;
            case 500:
              this.error = this.translate.instant('FORGOT_PASSWORD.ERRORS.SERVER');
              break;
            default:
              this.error = err.message ? err.message : this.translate.instant('FORGOT_PASSWORD.ERRORS.SERVER');
              break;
          }
        }
      });
  }
}
